import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ProfileContent from '../../../components/comment/profile/profileContent';
import CurrentBalance from './currentBalance';
import PrepaidCredit from './prepaidCredit';
import PaymentMethod from './paymentMethod';


const addMoney = () => {
  return (
    <div className=" add-money-wrap">
    <Container className="main-account-content ">
      <Row className="main-content pt-4 pb-5">
        <Col lg={3} className="content-left">
          <ProfileContent />
        </Col>

        <Col lg={9} className="content-right  " >
          <div className='verification-wrap'>
            <CurrentBalance />
            <PrepaidCredit />
            <PaymentMethod />
         </div>
        </Col>
      </Row>
    </Container>
  </div>
  )
}

export default addMoney